/**
 * pages/me/myFeedback.js — /me хуудасны «ХАБЭА санал гомдол» таб.
 *
 * Журмын үндэслэл: ХЭМАБМТ-08 4.1.3 — ажилтан «ХЭМАБ-ын үйл ажиллагааг
 * сайжруулахад чиглэсэн санал зөвлөгөө өгөх» ЭРХТЭЙ. Энэ таб нь тэр
 * эрхийг хэрэгжүүлэх хамгийн хүртээмжтэй оролт: ажилтан өдөр тутам
 * хэрэглэдэг хуудсан дээрээ, цэсний эрхээс ҮЛ ХАМААРЧ бичнэ.
 *
 * ⚠ ЦЭСНЭЭС ХАМААРУУЛААГҮЙ: цэс нь SSO-гийн эрхээр хумигддаг бөгөөд
 *   ажилтны ихэнхэд ХАБЭА-гийн цэс огт байдаггүй. Хэрэв санал бичих
 *   оролт зөвхөн цэсэнд байвал 4.1.3-ын эрх цаасан дээр үлдэнэ.
 *
 * ⚠ БИЧСЭНИЙ ХАРИУГ МӨН ЭНД харуулна. Хариугүй санал бол систем хоёр
 *   дахь удаа ашиглагдахгүй — ажилтан «бичлээ, юу болсныг мэдэхгүй»
 *   гэсэн туршлага нэг л удаа хэрэгтэй.
 *
 * ⚠ Хоолны санал гомдол (/hygiene/register) нь ӨӨР МОДУЛЬ. Энэ нь
 *   ерөнхий ХАБЭА — ажлын байрны аюулгүй байдал, ХХХ, сургалт, журам…
 */
import React, { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  Switch,
  Upload,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";

import {
  hseFeedbackApi,
  FB_STATUS_COLOR,
  FB_KIND_META,
} from "src/api/hseFeedbackApi";
import { uploadHazardPhoto } from "src/api/hazard";

const MUTED = "#8A94A6";
const BRAND = "#0D7FD6";

/** Нэг хуудсанд харуулах мөр. Санал гомдол нь аюулын бүртгэл шиг олон
 *  болдоггүй тул 20 хангалттай; «бүгдийг» товч хэрэггүй. */
const PER_PAGE = 20;

const kindMeta = (k) => FB_KIND_META[k] || FB_KIND_META.suggestion;

/* ── Нэг мөр ───────────────────────────────────────────────────────── */
function Row1({ it, onOpen }) {
  const km = kindMeta(it.kind);
  return (
    <button
      type="button"
      onClick={() => onOpen(it)}
      style={{
        display: "flex",
        width: "100%",
        gap: 10,
        alignItems: "flex-start",
        padding: "9px 10px",
        border: "1px solid #E7ECF3",
        borderRadius: 8,
        background: "#fff",
        textAlign: "left",
        cursor: "pointer",
        marginBottom: 6,
      }}
    >
      <span
        style={{
          width: 30,
          height: 30,
          flexShrink: 0,
          borderRadius: 7,
          background: km.color + "1A",
          color: km.color,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className={"fas " + km.icon} />
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span
          style={{
            display: "block",
            fontWeight: 700,
            fontSize: 13,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {it.title || it.content}
        </span>
        <span style={{ display: "block", fontSize: 11, color: MUTED }}>
          {it.code} · {it.category_name || "—"}
          {it.insert_date ? " · " + String(it.insert_date).slice(0, 10) : ""}
        </span>
      </span>
      <span style={{ flexShrink: 0, textAlign: "right" }}>
        <span
          style={{
            display: "inline-block",
            fontSize: 10.5,
            fontWeight: 700,
            padding: "2px 7px",
            borderRadius: 20,
            color: "#fff",
            background: FB_STATUS_COLOR[it.status] || MUTED,
          }}
        >
          {it.status_label}
        </span>
        {/* ⚠ Хугацаа хэтэрсэн нь ажилтанд ч харагдах ёстой: тэр үед
            ажилтан өөрөө сануулах эрхтэй болно. */}
        {it.is_overdue ? (
          <span
            style={{
              display: "block",
              fontSize: 10,
              color: "#E5484D",
              marginTop: 3,
            }}
          >
            хугацаа хэтэрсэн
          </span>
        ) : null}
        {it.reward_label ? (
          <span
            style={{
              display: "block",
              fontSize: 10,
              color: "#1F9D55",
              marginTop: 3,
            }}
          >
            <i className="fas fa-award" /> урамшуулалд
          </span>
        ) : null}
      </span>
    </button>
  );
}

/* ── Дэлгэрэнгүй цонх ──────────────────────────────────────────────── */
function Detail({ id, onClose }) {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    let alive = true;
    setLoading(true);
    hseFeedbackApi
      .get(id)
      .then((r) => alive && setD(r?.item || null))
      .catch(() => alive && setD(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [id]);

  const it = d || {};
  const km = kindMeta(it.kind);
  const line = (label, value) =>
    value ? (
      <div style={{ marginBottom: 7 }}>
        <div style={{ fontSize: 11, color: MUTED }}>{label}</div>
        <div style={{ fontSize: 12.5, whiteSpace: "pre-wrap" }}>{value}</div>
      </div>
    ) : null;

  return (
    <Modal
      open={!!id}
      onCancel={onClose}
      footer={null}
      width={680}
      style={{ top: 24, maxWidth: "96vw" }}
      title={
        <span>
          <i
            className={"fas " + km.icon}
            style={{ color: km.color, marginRight: 7 }}
          />
          {it.code || "Санал гомдол"}
          <span
            style={{
              marginLeft: 8,
              fontSize: 11,
              fontWeight: 700,
              padding: "2px 7px",
              borderRadius: 20,
              color: "#fff",
              background: FB_STATUS_COLOR[it.status] || MUTED,
            }}
          >
            {it.status_label}
          </span>
        </span>
      }
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      ) : !d ? (
        <Empty description="Татаж чадсангүй" />
      ) : (
        <div>
          {it.title ? (
            <div style={{ fontWeight: 800, fontSize: 14, marginBottom: 6 }}>
              {it.title}
            </div>
          ) : null}
          {line("Чиглэл", it.category_name)}
          {line("Дэлгэрэнгүй", it.content)}
          {line("Хаана", it.place_text)}
          {line("Хамаарах нэгж", it.tseh_name || it.tseh_code)}
          {line("Болсон өдөр", it.happened_date)}
          {line("Шийдвэрлэх хугацаа", it.due_date)}

          {/* ХАРИУ — ажилтны хувьд ХАМГИЙН ЧУХАЛ хэсэг */}
          {it.assigned_tseh_name || it.assigned_name ? (
            <Alert
              type="info"
              showIcon
              style={{ margin: "10px 0" }}
              message="Хуваарилагдсан"
              description={
                (it.assigned_tseh_name || "") +
                (it.assigned_name ? " · " + it.assigned_name : "") +
                (it.assign_note ? " — " + it.assign_note : "")
              }
            />
          ) : null}
          {it.resolution_note ? (
            <Alert
              type="success"
              showIcon
              style={{ margin: "10px 0" }}
              message={
                "Авсан арга хэмжээ" +
                (it.resolved_by_name ? " · " + it.resolved_by_name : "")
              }
              description={it.resolution_note}
            />
          ) : null}
          {it.closed_note ? (
            <Alert
              type={it.status === "rejected" ? "warning" : "info"}
              showIcon
              style={{ margin: "10px 0" }}
              message={
                it.status === "rejected" ? "Үндэслэлгүй гэсэн шалтгаан" : "Хаалтын тайлбар"
              }
              description={it.closed_note}
            />
          ) : null}
          {it.reward_label ? (
            <Alert
              type="success"
              showIcon
              style={{ margin: "10px 0" }}
              message={"Урамшуулал — " + it.reward_label}
              description={
                (it.reward_note || "") +
                (it.reward_score != null ? " (оноо: " + it.reward_score + ")" : "")
              }
            />
          ) : null}

          {(it.files || []).length ? (
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
              {it.files.map((f) => (
                <a key={f.id} href={f.file_url} target="_blank" rel="noreferrer">
                  <img
                    src={f.file_url}
                    alt=""
                    style={{ width: 86, height: 70, objectFit: "cover", borderRadius: 6 }}
                  />
                </a>
              ))}
            </div>
          ) : null}

          {/* ТҮҮХ — ХЭМАБМТ-14 4.2.3.2 «шударга бүртгэнэ»: ажилтан өөрөө
              хэн хэзээ юу шийдсэнийг харна. */}
          {(it.history || []).length ? (
            <div style={{ marginTop: 12, borderTop: "1px solid #EEF2F7", paddingTop: 8 }}>
              <div style={{ fontSize: 11, color: MUTED, marginBottom: 5 }}>
                Явц
              </div>
              {it.history.map((h) => (
                <div key={h.id} style={{ fontSize: 11.5, marginBottom: 3 }}>
                  <span style={{ color: MUTED }}>{h.insert_date}</span>{" "}
                  <b>{h.action_label}</b>
                  {h.user_name ? " · " + h.user_name : ""}
                  {h.note ? " — " + h.note : ""}
                </div>
              ))}
            </div>
          ) : null}
        </div>
      )}
    </Modal>
  );
}

/* ── Таб ───────────────────────────────────────────────────────────── */
export default function MyFeedback() {
  const [form] = Form.useForm();
  const [cats, setCats] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [anon, setAnon] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [page, setPage] = useState(1);
  // Лавлах хоосон эсэх — чиглэл байхгүй бол бүртгэх боломжгүй тул
  // хэрэглэгчид «алдаа» гэж харуулахгүй, шалтгааныг хэлнэ.
  const [refErr, setRefErr] = useState(false);
  /* ⚠ ТӨРӨЛ (2026-10-04). Хоолны санал гомдол нь ӨӨР хаягтай
     (/hygiene/register) байсныг энэ маягтын ТӨРӨЛ болгож авав —
     ажилтанд «хаана юу бичдэг» гэсэн асуулт үүсэхгүй байх нь гол.
     Төрөл солигдоход БӨГЛӨХ ТАЛБАРУУД ч солигдоно:
       general → Хаана (чөлөөт текст) · Болсон өдөр
       meal    → Хоолны байршил (лавлах) · Хоол гарсан өдөр
     Шалтгаан: хоолны гомдлыг ХЭН рүү шилжүүлэхийг БАЙРШИЛ нь
     тодорхойлдог (байршил → хоол үйлдвэрлэгч) тул чөлөөт текст
     хүрэлцэхгүй. */
  const [topic, setTopic] = useState("general");
  const isMeal = topic === "meal";
  const [mealLocs, setMealLocs] = useState([]);

  const load = useCallback(() => {
    setLoading(true);
    hseFeedbackApi
      .list({ mine: 1 })
      .then((r) => setItems(r?.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  /* ⚠ Чиглэлийг ТӨРӨЛ СОЛИГДОХ БҮРД дахин татна. Нэг удаа татаад
     клиент дээр шүүвэл ХАБЭА хэлтэс шинэ чиглэл нэмэхэд хуудсаа
     refresh хийх хүртэл харагдахгүй байна. */
  useEffect(() => {
    let alive = true;
    hseFeedbackApi
      .categories(false, topic)
      .then((r) => {
        if (!alive) return;
        const list = r?.items || [];
        setCats(list);
        setRefErr(list.length === 0);
      })
      .catch(() => alive && setRefErr(true));
    return () => {
      alive = false;
    };
  }, [topic]);

  /* Хоолны байршлын лавлах — ЗӨВХӨН хэрэгтэй үед татна */
  useEffect(() => {
    if (!isMeal || mealLocs.length) return;
    hseFeedbackApi
      .mealLocations()
      .then((r) => setMealLocs(r?.items || []))
      .catch(() => setMealLocs([]));
  }, [isMeal, mealLocs.length]);

  const submit = async () => {
    try {
      const v = await form.validateFields();
      setSaving(true);
      await hseFeedbackApi.create({
        topic,
        kind: v.kind || "suggestion",
        category_id: v.category_id,
        title: (v.title || "").trim() || undefined,
        content: (v.content || "").trim(),
        /* ⚠ ТӨРЛИЙН ДАГУУ ЗӨВХӨН ХАМААРАХЫГ явуулна. Хоёуланг
           явуулбал нэгдсэн хүснэгтэд «хаана» гэсэн хоёр өөр утга
           (чөлөөт текст ба лавлахын байршил) зэрэг бичигдэж, тайланд
           аль нь үнэн болох нь мэдэгдэхгүй болно. */
        ...(isMeal
          ? {
              meal_location_id: v.meal_location_id,
              meal_date: v.meal_date
                ? v.meal_date.format("YYYY-MM-DD")
                : undefined,
            }
          : {
              place_text: (v.place_text || "").trim() || undefined,
              happened_date: v.happened_date
                ? v.happened_date.format("YYYY-MM-DD")
                : undefined,
              // 4.6.1 урамшуулал нь ХАБЭА-г сайжруулсан саналд л
              is_risk_reducing: !!v.is_risk_reducing,
            }),
        is_anonymous: !!v.is_anonymous,
        photo_urls: photos,
      });
      message.success("Хүлээн авлаа — хариуг нь эндээс харна");
      form.resetFields();
      setPhotos([]);
      setAnon(false);
      setPage(1);
      load();
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e?.response?.data?.message || "Хадгалж чадсангүй");
    } finally {
      setSaving(false);
    }
  };

  const shown = items.slice(0, page * PER_PAGE);

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} lg={10}>
        <div
          style={{
            border: "1px solid #E7ECF3",
            borderRadius: 10,
            padding: 12,
            background: "#FBFCFE",
          }}
        >
          <div style={{ fontWeight: 800, fontSize: 13.5, marginBottom: 2 }}>
            Шинэ санал, гомдол
          </div>
          <div style={{ fontSize: 11, color: MUTED, marginBottom: 10 }}>
            Ажлын байрны аюулгүй байдал, ХХХ, тоног төхөөрөмж, сургалт,
            хөдөлмөрийн нөхцөлийн талаар
          </div>

          {refErr ? (
            <Alert
              type="warning"
              showIcon
              message="Чиглэлийн лавлах хоосон байна"
              description="ХАБЭА хэлтэс чиглэлийг бүртгэсний дараа бичих боломжтой болно."
            />
          ) : (
            <Form
              form={form}
              layout="vertical"
              size="small"
              initialValues={{ kind: "suggestion" }}
            >
              {/* ⚠ ТӨРӨЛ нь Form-ийн ГАДНА (useState): түүнээс
                  ХАРАГДАХ ТАЛБАРУУД шалтгаалдаг тул `Form.Item`-ийн
                  дотор байрлуулбал `resetFields` төрлийг ч хаяж,
                  бөглөж байсан маягт нь ерөнхий болж хувирна. */}
              <div style={{ marginBottom: 10 }}>
                <Radio.Group
                  value={topic}
                  buttonStyle="solid"
                  size="small"
                  onChange={(e) => {
                    setTopic(e.target.value);
                    /* ⚠ ЧИГЛЭЛИЙГ ЗААВАЛ ЦЭВЭРЛЭНЭ: хуучин төрлийн
                       чиглэлийн id үлдвэл backend «Чиглэл нь сонгосон
                       төрөлд хамаарахгүй» гэж 400 буцаана. */
                    form.setFieldsValue({
                      category_id: undefined,
                      meal_location_id: undefined,
                    });
                  }}
                >
                  <Radio.Button value="general">ХАБЭА</Radio.Button>
                  <Radio.Button value="meal">Халуун хоол</Radio.Button>
                </Radio.Group>
              </div>

              <Form.Item name="kind" style={{ marginBottom: 10 }}>
                <Radio.Group buttonStyle="solid" size="small">
                  <Radio.Button value="suggestion">Санал</Radio.Button>
                  <Radio.Button value="complaint">Гомдол</Radio.Button>
                  <Radio.Button value="question">Хүсэлт</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                name="category_id"
                label="Чиглэл"
                rules={[{ required: true, message: "Чиглэлээ сонгоно уу" }]}
              >
                <Select
                  showSearch
                  optionFilterProp="label"
                  placeholder={
                    isMeal ? "Амт чанар, цэвэрлэгээ …" : "Юуны талаар вэ"
                  }
                  options={cats.map((c) => ({ value: c.id, label: c.name }))}
                />
              </Form.Item>

              <Form.Item name="title" label="Товч гарчиг">
                <Input maxLength={300} placeholder="Жишээ: Гарцны гэрэлтүүлэг ажиллахгүй" />
              </Form.Item>

              <Form.Item
                name="content"
                label="Дэлгэрэнгүй"
                rules={[{ required: true, message: "Дэлгэрэнгүй бичнэ үү" }]}
                extra="Юу, хаана, хэзээ — тодорхой бичих тусам хурдан шийдэгдэнэ"
              >
                <Input.TextArea rows={4} maxLength={4000} showCount />
              </Form.Item>

              {/* ⚠ ТАЛБАР СОЛИГДОХ ХЭСЭГ. Хоолны гомдолд «хаана»
                  нь чөлөөт текст байж БОЛОХГҮЙ: гомдлыг хэн рүү
                  шилжүүлэхийг БАЙРШИЛ тодорхойлдог (байршил → хоол
                  үйлдвэрлэгч). Текст бичүүлбэл ХАБЭАХ гар аргаар
                  тааруулах шаардлагатай болно. */}
              <Row gutter={8}>
                {isMeal ? (
                  <>
                    <Col xs={24} sm={14}>
                      <Form.Item
                        name="meal_location_id"
                        label="Хоолны байршил"
                        rules={[
                          { required: true, message: "Байршлаа сонгоно уу" },
                        ]}
                        extra="Хаана хоол идсэн вэ"
                      >
                        <Select
                          showSearch
                          optionFilterProp="label"
                          placeholder="Цайны газар, ABK …"
                          options={mealLocs.map((l) => ({
                            value: l.id,
                            label: l.name,
                          }))}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={10}>
                      <Form.Item name="meal_date" label="Хоол гарсан өдөр">
                        <DatePicker style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xs={24} sm={14}>
                      <Form.Item name="place_text" label="Хаана">
                        <Input
                          maxLength={400}
                          placeholder="Ажлын байр, объект"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={10}>
                      <Form.Item name="happened_date" label="Болсон өдөр">
                        <DatePicker style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>

              <Form.Item label="Зураг" style={{ marginBottom: 10 }}>
                <Upload
                  listType="text"
                  multiple
                  fileList={[]}
                  accept="image/*"
                  customRequest={async ({ file, onSuccess, onError }) => {
                    try {
                      /* ⚠ `uploadHazardPhoto` нь МӨР биш ОБЪЕКТ буцаана
                         (`{file_url, file_name, file_size, content_type}` —
                         Flask/Resources/mobile/upload.py). Объектыг шууд
                         хийвэл `<img src>` нь "[object Object]" болж,
                         backend-д `file_url` багана руу dict бичих гэж
                         оролдоод INSERT унана. Бусад нэрийг нөөц болгов
                         (FindingPhotos.js-тэй ижил дүрэм). */
                      const up = await uploadHazardPhoto(file);
                      const url = up?.file_url || up?.url || up?.photo_url;
                      if (!url) throw new Error("Хаяг ирсэнгүй");
                      setPhotos((p) => [...p, url]);
                      onSuccess?.();
                    } catch (err) {
                      onError?.(err);
                      message.error("Зураг хуулж чадсангүй");
                    }
                  }}
                >
                  <Button icon={<UploadOutlined />} size="small">
                    Зураг нэмэх
                  </Button>
                </Upload>
                {photos.length ? (
                  <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
                    {photos.map((u) => (
                      <img
                        key={u}
                        src={u}
                        alt=""
                        style={{ width: 62, height: 50, objectFit: "cover", borderRadius: 6 }}
                      />
                    ))}
                  </div>
                ) : null}
              </Form.Item>

              {/* ХЭМАБМТ-08 4.6.1.2 «Зөв идэвхийн систем» — аюул эрсдэлийг
                  бууруулсан санал. Ажилтан өөрөө тэмдэглэнэ, ХАБЭАХ нь
                  хаалт тавихдаа батална. */}
              <Form.Item
                name="is_risk_reducing"
                label="Аюул, эрсдэлийг бууруулах санал"
                valuePropName="checked"
                style={{ marginBottom: 8 }}
                extra="Журмын 4.6.1.2 «Зөв идэвхийн систем»-д хамрагдаж болно"
              >
                <Switch size="small" />
              </Form.Item>

              <Form.Item
                name="is_anonymous"
                label="Нэрээ нууцлах"
                valuePropName="checked"
                style={{ marginBottom: 8 }}
              >
                <Switch size="small" onChange={setAnon} />
              </Form.Item>
              {anon ? (
                /* ⚠ ИЛ ТАЙЛБАР: «нэрээ нууцлах» нь бүрэн нэргүй ГЭСЭН ҮГ
                   БИШ. Хэрэглэгч буруу ойлговол итгэл алдана. */
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 10 }}
                  message="Таны нэр бусдад харагдахгүй"
                  description="Хуваарилагдсан нэгж болон ХАБЭА хэлтэст таны нэр, нэгж харагдахгүй. Гэхдээ хариуг тань руу буцааж хүргэх, урамшууллыг эзэнд нь бодохын тулд систем дотор холбоос үлдэнэ."
                />
              ) : null}

              <Button
                type="primary"
                block
                loading={saving}
                onClick={submit}
                style={{ background: BRAND, borderColor: BRAND }}
              >
                Илгээх
              </Button>
            </Form>
          )}
        </div>
      </Col>

      <Col xs={24} lg={14}>
        <div style={{ fontWeight: 800, fontSize: 13.5, marginBottom: 8 }}>
          Миний бичсэн санал, гомдол
          {items.length ? (
            <span style={{ color: MUTED, fontWeight: 500 }}> ({items.length})</span>
          ) : null}
        </div>
        {loading ? (
          <div style={{ textAlign: "center", padding: 24 }}>
            <Spin />
          </div>
        ) : !items.length ? (
          <Empty
            description="Бичсэн санал гомдол байхгүй"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <>
            {shown.map((it) => (
              <Row1 key={it.id} it={it} onOpen={(x) => setOpenId(x.id)} />
            ))}
            {items.length > shown.length ? (
              <Button size="small" block onClick={() => setPage((p) => p + 1)}>
                Дараагийн {Math.min(PER_PAGE, items.length - shown.length)}
              </Button>
            ) : null}
          </>
        )}
      </Col>

      <Detail id={openId} onClose={() => setOpenId(null)} />
    </Row>
  );
}
